import React, { useState, useEffect } from "react";
import axios from "axios";
import "./assetreport.css";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx"; // Import xlsx library
import Select from "react-select"; // add this line if not present

const AssetReportAudit = () => {
  const [company, setCompany] = useState("");
  const [department, setDepartment] = useState("");
  const [category, setcategory] = useState("");
  const [type, setType] = useState("");
  const [selectedComputerComponent, setSelectedComputerComponent] =
    useState("");
  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [categories, setCategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [allTypes, setAllTypes] = useState({});
  const [computerComponentOptions, setComputerComponentOptions] = useState([]);
  const [assetRegisterDetails, setAssetRegisterDetails] = useState([]);
  const [filteredAssets, setFilteredAssets] = useState([]);
  const[subComponent,setSubComponent]=useState("");

  useEffect(() => {
    fetchAssets();
  }, []);

  const fetchAssets = async () => {
    try {
      const response = await axios.get(
        "/api/AssetRegisterDetails/getAssetDetails"
      );
      setAssetRegisterDetails(response.data);

      // Extract unique values
      const uniqueCompanies = [
        ...new Set(response.data.map((asset) => asset.company)),
      ];
      const uniqueDepartments = [
        ...new Set(response.data.map((asset) => asset.department)),
      ];
      const uniqueCategories = [
        ...new Set(response.data.map((asset) => asset.category)),
      ];
      const uniqueComponents = [
        ...new Set(response.data.map((asset) => asset.subComponent)),
      ].filter(Boolean); // Ensure no empty values

      setCompanies(uniqueCompanies);
      setDepartments(uniqueDepartments);
      setCategories(uniqueCategories);
      setComputerComponentOptions(uniqueComponents);

      // Group types by category
      const groupedTypes = response.data.reduce((acc, asset) => {
        if (!acc[asset.category]) {
          acc[asset.category] = new Set();
        }
        acc[asset.category].add(asset.type);
        return acc;
      }, {});

      setAllTypes(groupedTypes);
    } catch (error) {
      console.error("Error fetching asset details:", error);
    }
  };

  useEffect(() => {
    filterAssets();
  }, [company, department, category, type, subComponent]);

  useEffect(() => {
    // Update types dropdown when category changes
    setTypes(category ? [...(allTypes[category] || [])] : []);
    setType(""); // Reset type selection
  }, [category]);

  const filterAssets = () => {
    let filtered = assetRegisterDetails;

    if (company)
      filtered = filtered.filter((asset) => asset.company === company);
    if (department)
      filtered = filtered.filter((asset) => asset.department === department);
    if (category)
      filtered = filtered.filter(
        (asset) => asset.category === category
      );
    if (type) filtered = filtered.filter((asset) => asset.type === type);
    if (subComponent)
      filtered = filtered.filter(
        (asset) => asset.subComponent === subComponent
      );

    setFilteredAssets(filtered);
  };

  // Function to download the filtered assets as Excel
  const downloadExcel = () => {
    if (filteredAssets.length === 0) {
      alert("No data available for download.");
      return;
    }

    // Define column headers
    const headers = [
      "Registered Name",
      "Company",
      "Department","Category","Type",
    "Sub Components","Asset Name","EPF No & Recipient Name","Model",
    "Register Date","Transfer Date","Serial Number","Tracking ID","Price",
    "Asset Image","Invoice Image","Warranty","Supplier Name","Invoice Number","Purchase Date"
    ];

    // Map data to match column headers
    const data = filteredAssets.map((asset) => ({
      "Registered Name": asset.name,
      "Company": asset.company,
      "Department": asset.department,
      "Category": asset.category,
      "Type": asset.type,
      "Sub Components": asset.subComponent,
      "Asset Name": asset.assetName,
      "EPF No & Recipient Name": asset.assetUserName,
     "Model": asset.assetModel,
      "Register Date": asset.assetUpdateDate,
      "Transfer Date": asset.assetTransferDate,
      "Serial Number": asset.serialNumber,
      
      "Tracking ID": asset.trackingId,
      "Price": asset.assetprice,
      "Asset Image": asset.assetImageURL || "No Image",
      "Invoice Image": asset.invoiceFileURL || "No Invoice",
      "Warranty": asset.warranty || "-",
      "Supplier Name": asset.supplierName || "-",
      "Invoice Number": asset.invoiceDetails || "-",
      "Purchase Date": asset.purchaseDate || "-"
    }));

    // Create worksheet with headers
    const ws = XLSX.utils.json_to_sheet(data, {
      header: headers,
      skipHeader: false,
    });

    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Filtered Assets");

    // Save file
    XLSX.writeFile(wb, "Filtered_Asset_Report.xlsx");
  };

  const toOptions = (arr) => arr.map((v) => ({ value: v, label: v }));

  return (
    <div>
      <h1 className="assethead" style={{ marginTop: "20px" }}>
        Download Report
      </h1>
      <p>
        <Link to="/AuditDashBoard">Dashboard</Link> /{" "}
        <Link to="/AssetReport">Report Details</Link>
      </p>

      {/* Filters Section */}
      <div className="filters">
        {/* Company */}
        <Select
          classNamePrefix="react-select"
          placeholder="Select Company"
          options={toOptions(companies)}
          value={company ? { value: company, label: company } : null}
          onChange={(sel) => setCompany(sel ? sel.value : "")}
          isClearable
        />

        {/* Department */}
        <Select
          classNamePrefix="react-select"
          placeholder="Select Department"
          options={toOptions(departments)}
          value={department ? { value: department, label: department } : null}
          onChange={(sel) => setDepartment(sel ? sel.value : "")}
          isClearable
        />

        {/* Main Category */}
        <Select
          classNamePrefix="react-select"
          placeholder="Select Category"
          options={toOptions(categories)}
          value={
            category ? { value: category, label: category } : null
          }
          onChange={(sel) => setcategory(sel ? sel.value : "")}
          isClearable
        />

        {/* Type – only when a category is chosen */}
        {category && (
          <Select
            classNamePrefix="react-select"
            placeholder="Select Type"
            options={toOptions(types)}
            value={type ? { value: type, label: type } : null}
            onChange={(sel) => setType(sel ? sel.value : "")}
            isClearable
          />
        )}

        {/* Computer components – only when Type === "Computer" */}
        {type === "Desktop Computers" && (
                  <Select
                    placeholder="Select Component"
                    options={toOptions(computerComponentOptions)}
                    value={
                      subComponent
                        ? { value: subComponent, label: subComponent }
                        : null
                    }
                    onChange={sel => setSubComponent(sel?.value || "")}
                    isClearable
                  />
                )}
      </div>

      <div className="download-container">
        <button onClick={downloadExcel} className="download-btn1">
          Report <i className="fas fa-download"></i>
        </button>
      </div>

      {/* Display Filtered Results */}
      {filteredAssets.length > 0 ? (
        <div>
          <table className="asset-table custom_table">
            <thead>
              <tr>
                <th>Registered Name</th>
                
              <th>Company</th>
              <th>Department</th>
              <th>Category</th>
              <th>Type</th>
              <th>Sub Components</th>
              <th>Asset Name</th>
              <th>EPF No & Recipient Name</th>
              <th>Model</th>
              <th>Register Date</th>
              <th>Transfer Date</th>
              <th>Serial</th>
              <th>Tracking ID</th>
              <th>Price</th>
              
              <th>Asset Image</th>
              <th>Invoice Image</th>
              <th>Warranty</th>
              <th>Supplier Name</th>
              <th>Invoice Number</th>
              <th>Purchase Date</th>
              </tr>
            </thead>
            <tbody>
              {filteredAssets.map((asset, index) => (
                <tr key={index}>
                  <td>{asset.name}</td>
                    <td>{asset.company}</td>
                    <td>{asset.department}</td>
                    <td>{asset.category}</td>
                    <td>{asset.type}</td>
                     <td>{asset.subComponent || "-"}</td>
                    <td>{asset.assetName}</td>
                    <td>{asset.assetUserName}</td>
                    <td>{asset.assetModel}</td>
                    <td>{asset.assetUpdateDate}</td>
                    <td>{asset.assetTransferDate}</td>
                    <td>{asset.serialNumber}</td>
                    <td>{asset.trackingId}</td>
                    <td>{asset.assetprice}</td>
                    <td>
                      {asset.assetImageURL ? (
                        <a
                          href={asset.assetImageURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Image
                        </a>
                      ) : (
                        "No Image"
                      )}
                    </td>

                    <td>
                      {asset.invoiceFileURL ? (
                        <a
                          href={asset.invoiceFileURL}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Invoice
                        </a>
                      ) : (
                        "No Invoice"
                      )}
                    </td>
                    <td>{asset.warranty || "-"}</td>
                    <td>{asset.supplierName || "-"}</td>
                    <td>{asset.invoiceDetails || "-"}</td>
                    <td>{asset.purchaseDate || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No matching assets found.</p>
      )}
    </div>
  );
};

export default AssetReportAudit;
